// @flow
/* global _LTracker */
import * as React from 'react';
import { render } from 'react-dom';
import { LocalizeProvider } from 'react-localize-redux';
import { ErrorBoundary } from 'react-error-boundary';
import OnlineWaiver from './OnlineWaiver';
import { loadReCaptcha } from 'react-recaptcha-v3';

import './index.css';

const myErrorHandler = (error: Error, componentStack: string) => {
  _LTracker.push({
    error, info: {
      type: `Unhandled Exception`,
      details: componentStack
    }
  });
};

const App = props => (
  <React.Fragment>
    {/* <ErrorBoundary onError={myErrorHandler}> */}
      <LocalizeProvider>
        <OnlineWaiver />
      </LocalizeProvider>
    {/* </ErrorBoundary> */}
  </React.Fragment>
);

loadReCaptcha('6LfpdX0UAAAAAHy2VAjDtsJi9Ba6LW_ao4OXlWe9');

render(
    <App />,
  // $FlowFixMe
  document.getElementById(`waiver-root`)
);